import type IPicture from './IPicture';

enum TagName {
  LOW_CALORIES = '<600 Calories',
  BONE_HEALTH = 'Bone Health',
  CHEFS_CHOICE = 'Chef\'s Choice',
  GLUTEN_FREE = 'Gluten-Free',
  HEALTHY_CARBS = 'Healthy Carbs',
  HEART_HEALTH = 'Heart Health',
  HIGH_FIBER = 'High Fiber',
  HIGH_PROTEIN = 'High-Protein',
  LESS_PREP = 'Less Prep',
  LOW_SODIUM = 'Low Sodium',
  NUT_FREE = 'Nut-Free',
  SOY_FREE = 'Soy-Free',
  SPICY = 'Spicy',
}

type SkuTag = {
  id: number;
  name: TagName | string;
  promo: boolean;
};

type SkuImage = {
  image: { url: string; };
  srcSet?: string;
  image_alt: string;
  position: number;
  sku_id: number;
}

interface ISku {
  id: number;
  product_id: number;
  title: string;
  subtitle: string;
  description: string;
  meal_type: string;
  product_type: string;
  product_type_name: string;
  product_line_name: string;
  link_to_product: string;
  tags: SkuTag[];
  image_versions: IPicture[];
  plan_group: string;
  is_lto_box: boolean;
  is_lto_recommended_addon: boolean;
  lto_servings: string;
  servings?: number;
  prep_and_cook_time: number;
  calories: number;
  spec: string;
  price: string;
  subscription_price_per_serving: number;
  brand: string;
  favorite: boolean;
  volume: string;
  sales_price: number;
  ingredients_quantity: number;
  is_lto_component: boolean;
  images: SkuImage[];
}

export { TagName };
export type { SkuTag };
export type { SkuImage };
export default ISku;
